<template>
    <div id="user-create-view" class="view form-view">
        <h2>Create driver</h2>

        <driver-form :form="form" :handler="createDriver"></driver-form>
    </div>
</template>

<script>
import DriverForm from './components/DriverForm'
import DriversApi from '@/api/DriversApi'
import toast from '../../plugins/izitoast'
import router from '../../router/routes'
import { mapGetters } from 'vuex'

const driversApi = new DriversApi()

export default {
    name: 'CreateDriver',
    components: {
        DriverForm
    },
    data () {
        return {
            form: {
                name: '',
                firstName: '',
                lastName: '',
                phoneNumber: '',
                organization: null,
                fleet: null,
                user: null
            }
        }
    },
    computed: {
        ...mapGetters('authModule', [
            'getActiveOrganization'
        ])
    },
    methods: {
        async createDriver (form) {
            const {
                name,
                firstName,
                lastName,
                phoneNumber,
                organization,
                fleet,
                user
            } = form

            const response = await driversApi.createDriver({
                name,
                firstName,
                lastName,
                phoneNumber,
                organizationId: this.getActiveOrganization,
                fleetId: fleet ? fleet.id : null,
                userId: user ? user.id : null
            })

            if (!response.isSuccess) {
                return
            }

            toast.success('Driver successfully created.')
            if (this.hasAllRoles(['DriverUpdate'])) {
                router.push('/settings/drivers/edit/' + response.payload)
            }
        }
    }
}
</script>

<style scoped>

</style>
